import React, { useMemo, useState } from "react";
import { LockKeyhole } from "lucide-react";
import "./SitePasswordGate.css";

const SITE_PASSWORD =
  process.env.REACT_APP_ACCESS_PASSWORD || "default-password";
const SESSION_KEY = "quitpact_site_unlocked";

const SitePasswordGate = ({ children }) => {
  const [unlocked, setUnlocked] = useState(
    () => window.sessionStorage.getItem(SESSION_KEY) === "true",
  );
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const canSubmit = useMemo(() => password.trim().length > 0, [password]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (password === SITE_PASSWORD) {
      window.sessionStorage.setItem(SESSION_KEY, "true");
      setUnlocked(true);
      setError("");
      return;
    }

    setError("Incorrect password. Please try again.");
  };

  if (unlocked) return children;

  return (
    <main className="site-password" aria-labelledby="site-password-title">
      <section className="site-password__card">
        <img
          src="/logo.png"
          alt="QuitPact logo"
          className="site-password__logo"
        />

        <div className="site-password__icon" aria-hidden="true">
          <LockKeyhole size={28} strokeWidth={2.2} />
        </div>

        <h1 id="site-password-title" className="site-password__title">
          QuitPact is password protected
        </h1>

        <p className="site-password__copy">
          Enter the site password to continue.
        </p>

        <form className="site-password__form" onSubmit={handleSubmit}>
          <label className="site-password__label" htmlFor="site-password-input">
            Password
          </label>
          <input
            id="site-password-input"
            className="site-password__input"
            type="password"
            value={password}
            onChange={(event) => {
              setPassword(event.target.value);
              setError("");
            }}
            autoComplete="current-password"
            autoFocus
          />

          {error && <p className="site-password__error">{error}</p>}

          <button
            className="site-password__button"
            type="submit"
            disabled={!canSubmit}
          >
            Enter QuitPact
          </button>
        </form>
      </section>
    </main>
  );
};

export default SitePasswordGate;
